import { ChartAccountStatusTypeEnum  } from "../../../dtos/accounting/IAccountDto";
import {AccountAnalyticTypeEnum} from "../../../enums/Accounting/AccountAnalyticTypeEnum";

  export const ChartAccountStatus = [
    {
      id: ChartAccountStatusTypeEnum.active,
      name: "Active",
    },
    {
      id: ChartAccountStatusTypeEnum.Passive,
      name: "Passive",
    },
  ];
export const accountTypeEnum = [
  {
    id: AccountAnalyticTypeEnum.Account,
    name: "Account",
  },
  {
    id: AccountAnalyticTypeEnum.Accrual,
    name: "Acrual",
  },
  {
    id: AccountAnalyticTypeEnum.Employee,
    name: "Employee",
  },
  {
    id: AccountAnalyticTypeEnum.CustomersPersons,
    name: "CustomersPersons",
  },
  {
    id: AccountAnalyticTypeEnum.Vendors,
    name: "Vendors",
  },
  {
    id: AccountAnalyticTypeEnum.Product,
    name: "products",
  },
  {
    id: AccountAnalyticTypeEnum.AnalyticsTypeOfIncomeExpenseItem,
    name: "AnaliticsTypeOfIncomeExpenseItem",
  },
  {
    id: AccountAnalyticTypeEnum.FixedAssets,
    name: "FixedAssets",
  },
  {
    id: AccountAnalyticTypeEnum.ExpenseItem,
    name: "ExpenseItem",
  },
  {
    id: AccountAnalyticTypeEnum.IntangibleAsset,
    name: "IntangibleAsset",
  },
  {
    id: AccountAnalyticTypeEnum.PassiveItem,
    name: "PassiveItem",
  },
  {
    id: AccountAnalyticTypeEnum.Tax,
    name: "Tax",
  },
  {
    id: AccountAnalyticTypeEnum.TaxGroup,
    name: "TaxGroup",
  },
  {
    id: AccountAnalyticTypeEnum.Persons,
    name: "Persons",
  },
  {
    id: AccountAnalyticTypeEnum.Vat,
    name: "Vat",
  },
  {
    id: AccountAnalyticTypeEnum.IncomeItem,
    name: "IncomeItem",
  },
  {
    id: AccountAnalyticTypeEnum.Unit,
    name: "Unit",
  },
  {
    id: AccountAnalyticTypeEnum.Divisions,
    name: "Divisions",
  },
  {
    id: AccountAnalyticTypeEnum.Bank,
    name: "Bank",
  },
  {
    id: AccountAnalyticTypeEnum.CustomerEmployee,
    name: "CustomerEmpoyee",
  },
  {
    id: AccountAnalyticTypeEnum.Convert,
    name: "Convert",
  },
  {
    id: AccountAnalyticTypeEnum.TaxType,
    name: "TaxType",
  },
];

 // export const ChartAccountQuantity = [
 //    {
 //      id: IsChartAccountQuantity.yes,
 //      name: "Yes",
 //    },
 //    {
 //      id: IsChartAccountQuantity.no,
 //      name: "No",
 //    },
 // ];
 //
 //   export const ChartAccountAmount = [
 //    {
 //      id: isChartAccountAmount.yes,
 //      name: "Yes",
 //    },
 //    {
 //      id: IsChartAccountQuantity.no,
 //      name: "No",
 //    },
 //   ];
 //
 //     export const ChartAccountCurrency = [
 //    {
 //      id: isChartAccountCurrency.yes,
 //      name: "Yes",
 //    },
 //    {
 //      id: IsChartAccountQuantity.no,
 //      name: "No",
 //    },
 //  ];